import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProductCategoryResponse } from '../models/categoria-producto.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface CategoriaProductoDrawerOptions {
  categoriaProductoId?: number;
  prefilledParentId?: number;
}

@Injectable({ providedIn: 'root' })
export class CategoriaProductoDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: CategoriaProductoDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly categoriaSaved$$ = new Subject<ProductCategoryResponse>();

  readonly state = this.state$.asObservable();
  readonly categoriaSaved$ = this.categoriaSaved$$.asObservable();

  open(options: CategoriaProductoDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(categoria: ProductCategoryResponse): void {
    this.categoriaSaved$$.next(categoria);
  }
}
